<script lang="ts">
	import { selectedCollection, selectedTag } from '../stores';
	import { page } from '$app/stores';
	import type { presenterShortCollection } from '$lib/api/rpc';
	import type { Collection } from '$lib/types/Collections';

	export let collection: Collection | presenterShortCollection | undefined;
	let href = `/${$page.params.hubPrefix}/${collection?.slug}`;

	$: isSelectedCollection = $selectedCollection?.id === collection?.id;
	$: containsSelectedTag = collection?.tags?.some((tag) => tag === $selectedTag);
</script>

<a {href} class="collection" class:isSelectedCollection>
	{collection?.name}
	{#if containsSelectedTag}
		<div class="selectedTag">{`#${$selectedTag}`}</div>
	{/if}
</a>

<style>
	.collection {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		block-size: 40px;
		opacity: 0.9;
		font-family: var(--presslyFontFamily);
		font-size: var(--fontSizeSmaller);
		text-transform: uppercase;
		border-block-end: solid 2px transparent;
	}

	.collection:hover {
		opacity: 1;
		text-decoration: none;
	}

	.isSelectedCollection {
		border-block-end: solid 2px var(--collectionsFontColor);
	}

	.selectedTag {
		overflow: hidden;
		opacity: 0.9;
		font-size: var(--fontSizeSmallest);
		text-align: center;
		text-overflow: ellipsis;
	}
</style>
